import React, { useCallback, useMemo, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useDenaliScopes } from '../filters/DenaliScopeProvider'
import Icon from '../../../atoms/Icon'
import SelectLabel from './SelectLabel'
import TypePopoverMenu from './TypePopoverMenu'

function DenaliScopeTypePicker ({ className, style, subTitle, showIcon }) {
  const { scopes, scopeKey, selectScopeKey } = useDenaliScopes()
  const options = useMemo(() => {
    return scopes.map(scope => ({
      label: scope.name,
      value: scope.name,
      icon: scope.icon
    }))
  }, [scopes])
  const selectedScope = useMemo(() => {
    return scopes.find(x => x.name === scopeKey)
  }, [scopes, scopeKey])
  const [open, setOpen] = useState(false)
  const handleToggle = useCallback(() => setOpen(p => !p), [setOpen])
  const anchorRef = useRef(null)

  return (
    <>
      <SelectLabel
        ref={anchorRef}
        open={open}
        onClick={handleToggle}
        style={style}
        className={className}
      >
        <div className='flex flex-row items-center gap-sm'>
          {showIcon ? (
            <div>
              <Icon name={selectedScope?.icon} customSize={48} />
            </div>
          ) : null}
          <div>
            {subTitle ? (
              <div style={{
                lineHeight: '10px',
                color: 'color-mix(in srgb, var(--text-color-main) 50%, transparent)'
              }}
              >
                {subTitle}
              </div>
            ) : null}
            <div className='font-size-sm' style={{ lineHeight: '35px' }}>{selectedScope?.name}</div>
          </div>
        </div>
      </SelectLabel>
      <TypePopoverMenu
        anchorEl={anchorRef.current}
        open={open}
        onSelect={(type) => selectScopeKey(type.value)}
        setOpen={setOpen}
        options={options}
      />
    </>
  )
}

DenaliScopeTypePicker.propTypes = {
  /** Shows label over ScopeTypePicker */
  subTitle: PropTypes.string,

  /** Show or hide the icon */
  showIcon: PropTypes.bool,

  /** Additional CSS classes */
  className: PropTypes.string,

  /** Additional CSS Styles */
  style: PropTypes.object
}

DenaliScopeTypePicker.defaultProps = {
  showIcon: true
}

export default DenaliScopeTypePicker
